//调查问卷
const roleBox               = () => import('@/components/role/roleBox');
const roleList              = () => import("@/components/role/roleList");
const roleInfo              = () => import('@/components/role/roleInfo');

export default {
  path: "/roleBox",
  name: "roleBox",
  component: roleBox,
  children: [
    { path: "roleList", component: roleList, name: "roleList" },
    { path: "roleInfo", component: roleInfo, name: "roleInfo" }
  ]
};



// WEBPACK FOOTER //
// ./src/router/routes/role.js